export default {"src":"/_next/static/image/public/landing/hand_left.e0b1bb354ef61adf5068b3139bc68cd5.svg","height":320,"width":298};